import { render, staticRenderFns } from "./LoyaltyInfoChip.vue?vue&type=template&id=117cc2f6&scoped=true&"
import script from "./LoyaltyInfoChip.vue?vue&type=script&lang=js&"
export * from "./LoyaltyInfoChip.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyInfoChip.vue?vue&type=style&index=0&id=117cc2f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117cc2f6",
  null
  
)

export default component.exports